module.exports = __webpack_public_path__ + "static/media/lightBulb.76ff0e10.svg";